export default "__VITE_ASSET__5b62b1e2__"